import { render, staticRenderFns } from "./FacilitiesSection.vue?vue&type=template&id=b5debde0&scoped=true&"
import script from "./FacilitiesSection.vue?vue&type=script&lang=js&"
export * from "./FacilitiesSection.vue?vue&type=script&lang=js&"
import style0 from "./FacilitiesSection.vue?vue&type=style&index=0&id=b5debde0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5debde0",
  null
  
)

export default component.exports